import React from 'react';
import Navbar from '../components/Navbar';
import './Refund.css';

function Refund() {
    return (
        <div className="page-container refund-page">
            <Navbar />

            <section className="refund-hero">
                <div className="container">
                    <div className="refund-hero-content">
                        <span className="section-badge">RETNINGSLINJER</span>
                        <h1 className="refund-title">
                            Refusjonsvilkår <span className="gradient-text"></span>
                        </h1>
                        <p className="refund-subtitle">
                            Sist oppdatert: 19. mars 2026
                        </p>
                    </div>
                </div>
            </section>

            <section className="refund-content">
                <div className="container">
                    <div className="refund-wrapper">
                        <div className="refund-section">
                            <h2>Refusjonspolicy</h2>
                            <p>
                                Takk for at du bruker plattformen "Snakk med Krishna". Vi verdsetter ditt engasjement for spirituell vekst og streber etter å gi deg den beste opplevelsen på nettstedet vårt.
                            </p>
                        </div>

                        <div className="refund-section">
                            <h2>Immaterielle og ugjenkallelige produkter ("Digitale produkter")</h2>
                            <p>
                                Vi tilbyr ikke refusjon for immaterielle og ugjenkallelige produkter ("Digitale produkter") etter at ordren er bekreftet og produktet er levert.
                            </p>
                            <p>
                                Våre hovedtjenester inkluderer tilgang til hellige samtaler guidet av AI og spirituelt innhold. På grunn av disse produktenes digitale natur er det ikke mulig å "returnere" dem når tilgangen først er gitt.
                            </p>
                        </div>

                        <div className="refund-section">
                            <h2>Brukerstøtte og hjelp</h2>
                            <p>
                                Hvis du har problemer med å motta tjenester, få tilgang til chatten eller opplever tekniske problemer, anbefaler vi at du kontakter vårt supportteam.
                            </p>
                            <p>
                                Teamet vårt vil gjøre alt vi kan for å gjøre din spirituelle reise uavbrutt og meningsfull.
                            </p>
                        </div>

                        <div className="refund-section">
                            <h2>Kontakt</h2>
                            <p>Hvis du har spørsmål om refusjonspolicyen, vennligst kontakt oss:</p>
                            <ul>
                                <li>Email: <a href="mailto:support@talktokrishna.ai">support@talktokrishna.ai</a></li>
                                <li>Nettside: <a href="/contact">Kontaktskjema</a></li>
                            </ul>
                        </div>

                        <div className="refund-footer-note">
                            <p>
                                <strong>Spirituelt engasjement:</strong> Ved å foreta et kjøp bekrefter og godtar du vilkårene i disse retningslinjene.
                                Vi takker deg oppriktig for at du er en del av "Snakk med Krishna"-familien.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Refund;
